export const MOBILE_VERIFY_MODAL_ID = 'mobile-verify' as const
